
import initStore from './initStore';
export const store = initStore();

export default store;
